module.exports = __webpack_public_path__ + "media/images/ic-loja-f71080a9c25b6492efb446db0f903867.png";